import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { makeStyles } from '@mui/styles';

import link from '../../constants/link';

const useStyles = /* istanbul ignore next */ makeStyles(({ palette, typography, spacing }) => {
  const commonStyle = {
    fontFamily: typography.body1.fontFamily,
    color: palette.text.onMain,
    textDecoration: 'none',
  };

  return {
    [link.VARIANT.BODY]: {
      ...commonStyle,
      color: palette.brand.main,
      textDecoration: 'underline',
    },
    [link.VARIANT.HEADER]: commonStyle,
    [link.VARIANT.FOOTER]: commonStyle,
    icon: {
      color: palette.text.inactive,
      fontSize: '1rem',
      marginLeft: spacing(0.5),
      position: 'relative',
      top: 4,
    },
  };
});

/**
 * @deprecated
 * ### Description
 * `Link` has been deprecated and replaced by Classify `Hyperlink`.
 *
 * ### Example
 * ```
 * import Hyperlink from '@classify/react-core-components/Hyperlink';
 *
 * <Hyperlink href="#" target="_blank">
 *   Should open in new tab
 * </Hyperlink>
 * ```
 */
export default function Link({
  className = '',
  children,
  variant = link.VARIANT.BODY,
  Component = 'a',
  ...otherProps
}) {
  const classes = useStyles();
  const shouldOpenInNewTab = otherProps.target === '_blank';
  const linkElement = (
    <Component className={`${classes[variant]} ${className}`} {...otherProps}>
      {children}
    </Component>
  );

  return shouldOpenInNewTab ? (
    <span>
      {linkElement}
      <OpenInNewIcon className={classes.icon} />
    </span>
  ) : (
    linkElement
  );
}
